const useDialogCloser = () => {
  return (stateChange: (value: boolean) => void) => {
    document.body.style.removeProperty('overflow');
    stateChange(false);
  };
};

export default useDialogCloser;
